import { IAccessContext, IComponentAccess, IStudentDto, IUserAccessResponse, UserRole } from '../models/access';

export function mapToUserAccessContext(accessData: IUserAccessResponse): IAccessContext[] | null {
  if (!accessData.studentDtoList.length) return null;

  // Group students by company/account to create separate contexts
  const contextMap = new Map<string, IAccessContext>();

  accessData.studentDtoList.forEach((student) => {
    const key = `${student.companyCode}-${student.accountCode}`;

    if (contextMap.has(key)) {
      const existing = contextMap.get(key)!;
      existing.studentIds.push(student.studentId);
      // Update to highest role if current student has higher role
      if (student.role === 'Admin' && existing.userRole === 'Co-Parent') {
        existing.userRole = 'Admin';
      }
    } else {
      contextMap.set(key, {
        accountCode: student.accountCode,
        companyCode: student.companyCode,
        userRole: student.role,
        studentIds: [student.studentId],
      });
    }
  });

  return Array.from(contextMap.values());
}

export function mapToComponentAccessContext(accessData: IUserAccessResponse): IComponentAccess[] | null {
  if (!accessData.rolesDtoList.length) return null;

  const componentAccess: IComponentAccess[] = [];

  accessData.rolesDtoList.forEach((role) => {
    role.screenDtoList.forEach((screen) => {
      componentAccess.push({
        userRole: role.roleName,
        componentName: screen.screenName,
        permissions: {
          canView: screen.viewPermission,
          canEdit: screen.editPermission,
          canDelete: screen.deletePermission,
          canCreate: screen.createPermission,
          canExecute: screen.executePermission,
        },
      });
    });
  });

  return componentAccess;
}

export function determineHighestUserRole(studentDtoList: IStudentDto[]): UserRole | null {
  if (!studentDtoList.length) return null;

  // Check if any student has Admin role
  const hasAdminRole = studentDtoList.some((student) => student.role === 'Admin');

  if (hasAdminRole) {
    return 'Admin';
  }

  // Fall back to Co-Parent if no Admin role found
  return 'Co-Parent';
}
